import type { CatalogRepository } from '#/domain/catalog/CatalogRepository'
import type {
  BulkAssignMetricsToOrganizationPayload,
  OrganizationMetricAssignment,
} from '#/domain/catalog/OrganizationMetricAssignment'

export class BulkAssignMetricsToOrganizationUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(
    organizationId: string,
    payload: BulkAssignMetricsToOrganizationPayload,
  ): Promise<OrganizationMetricAssignment[]> {
    return this.repository.bulkAssignMetricsToOrganization(organizationId, payload)
  }
}
